import { values } from 'xe-utils/methods'
import * as types from '../mutation-types'

const state = {
  markData: null,
  localPage: 1,
  tools: '',
  toolsCount: 0,
  markSelected: {},
  markCreate:{},
  editNode:{},
  currentImage: 0,
  editTemplate: null,
  standardUpdateTotal: 0,
  navHidden: '',
  editType: null,
  testTemplate: null,
  createTemplate: null,
  ctools: '',
  ctoolsCount: 0,
  certificateObj: {},
  imageItem: {},
  drawopen: 0,
  configKey: '',
  ocrResults: [],
  tabOCRName: '原文件',
  editpageTab:'first',
  groupList:[],

  neworiginData:[],
  resitem:{},
  itemerror:{},
  changeneworiginData:[],
  errornewpage:0,
  successData: [],
  fullExpand: 'icon-expandout',
  toolName: '',
  verifyData: null,
  degrees:'',
  switchAuto: true,
  addRowState: [],
  minusRowState: [],
  tableInputState: [],
  tableFocusState: [],
  tableBlurState: [],
  successTotal: 0,
  successAllData: [],
  tabSwitch: '',
  docTypeNum:1,
  moveshow:"", //是否显示标注图标
  siggingarrlist:[],
  demoFlag: false,
}

const getters = {
  markData: state => state.markData,
  localPage: state => state.localPage,
  tools: state => state.tools,
  toolsCount: state => state.toolsCount,
  markSelected: state => state.markSelected,
  markCreate: state => state.markCreate,
  editNode: state => state.editNode,
  currentImage: state => state.currentImage,
  testTemplate: state => state.testTemplate,
  editTemplate: state => state.editTemplate,
  createTemplate: state => state.createTemplate,
  navHidden: state => state.navHidden,

  editType: state => state.editType,
  ctools: state => state.ctools,
  ctoolsCount: state => state.ctoolsCount,
  certificateObj: state => state.certificateObj,
  imageItem: state => state.imageItem,
  drawopen: state => state.drawopen,
  ocrResults: state => state.ocrResults,
  neworiginData: state => state.neworiginData,
  changeneworiginData: state => state.changeneworiginData,
  configKey: state => state.configKey,
  tabOCRName: state => state.tabOCRName,
  editpageTab: state => state.editpageTab,
  groupList: state => state.groupList,
  resitem: state => state.resitem,
  itemerror: state => state.itemerror,
  errornewpage:state => state.errornewpage,
  successData: state => state.successData,
  fullExpand: state => state.fullExpand,
  toolName: state => state.toolName,
  docTypeNum: state=> state.docTypeNum,
  verifyData: state => state.verifyData,
  degrees: state => state.degrees,
  switchAuto: state => state.switchAuto,
  
  addRowState: state => state.addRowState,
  minusRowState: state => state.minusRowState,
  tableInputState: state => state.tableInputState,
  tableFocusState: state => state.tableFocusState,
  tableBlurState: state => state.tableBlurState,
  successTotal: state => state.successTotal,
  successAllData: state => state.successAllData,
  tabSwitch: state => state.tabSwitch,
  
  moveshow: state=> state.moveshow,
  siggingarrlist: state=>state.siggingarrlist,

  demoFlag: state=>state.demoFlag
}

const mutations = {
  [types.SETMARKDATA]: (state, value) => {
      state.markData = value
  },
  [types.SETLOCALPAGE]: (state, value) => {
      state.localPage = value
  },
  [types.OPENTOOLS]: (state, value) => {
      state.toolName = value;
      state.tools = value;
      state.toolsCount++;
  },
  [types.MARKSELECTED]: (state, value) => {
      state.markSelected = value;
  },
  [types.MARKCREATE]: (state, value) => {
      state.markCreate = value;
  },
  [types.EDITNODE]: (state, value) => {
      state.editNode = value;
  },
  [types.CURRENTIMAGE]: (state, value) => {
      state.currentImage = value;
  },
  [types.EDITTEMPLATE]: (state, value) => {
      state.editTemplate = value;
  },
  [types.CREATETEMPLATE]: (state, value) => {
      state.createTemplate = value;
  },
  [types.STANDARDUPDATETOTAL]: (state, value) => {
      state.standardUpdateTotal = value;
  },
  [types.SETNAVHIDDEN]: (state, value) => {
      state.navHidden = value;
  },
  [types.SETEDITTYPE]: (state, value) => {
      state.editType = value;
  },
  [types.SETTESTTEMPLATE]: (state, value) => {
      state.testTemplate = value;
  },
  [types.CREATETOOLS]: (state, value) => {
      state.ctools = value;
      state.ctoolsCount++;
  },
  [types.SETCERTIFICATE]: (state, value) => {
      state.certificateObj = value;
  },
  [types.SETIMAGEITEM]: (state, value) => {
      state.imageItem = value;
  },
  [types.DRAWOPEN]: (state, value) => {
      state.drawopen++;
      state.configKey = value;
  },
  [types.OCRRESULT]: (state, value) => {
      state.ocrResults = value;
  },
  [types.NEWORIGIBDATA]: (state, value) => {
      state.neworiginData = value;
  },
  [types.CHANGENEWORIGIBDATA]: (state, value) => {
      state.changeneworiginData = value;
  },
  [types.SETTABOCRNAME]: (state, value) => {
      state.tabOCRName = value;
  },
  [types.SETEDITPAGETAB]: (state, value) => {
      state.editpageTab = value;
  },
  // [types.GROUPLIKST]: (state, value) => {
  //     state.groupList = value;
  // },

  setCurGroupList(state, value) {
      state.groupList = value;
  },
  [types.SETRESITEN]: (state, value) => {
      state.resitem = value;
  },
  [types.SETITEMERROR]: (state, value) => {
      state.itemerror = value;
  },
  [types.SETERRORNEWPAGE]:(state,value) =>{
      state.errornewpage = value;
  },
  


[types.SETSUCCESSDATA]: (state, value) => {
    state.successData = value
},
[types.SETFULLEXPAND]: (state, value) => {
    state.fullExpand = value
},

[types.SETDOCTYPENUM]:(state,value) => {
    state.docTypeNum=value
},
[types.SETVERIFYDATA]: (state, value) => {
    state.verifyData = value
},

[types.SETDEGRESS]:(state, value) => {
    state.degrees=value
},



[types.SETSWITVHAUTO]: (state, value) => {
    state.switchAuto = value;
},

[types.SETADDROW]: (state, value) => {
    state.addRowState = value;
},
[types.SETMINUSROW]: (state, value) => {
    state.minusRowState = value;
},
[types.SETTABLEINPUT]: (state, value) => {
    state.tableInputState = value;
},
[types.SETTABLEFOCUS]: (state, value) => {
    state.tableFocusState = value;
},
[types.SETTABLEBLUR]: (state, value) => {
    state.tableBlurState = value;
},
[types.SETSUCCESSTOTAL]: (state, value) => {
    state.successTotal = value;
},
[types.SETSUCCESSALLDATA]: (state, value) => {
    state.successAllData = value;
},
[types.SETTABSWITCH]: (state, value) => {
    state.tabSwitch = value;
},



[types.SETMOVESHOW]:(state,value) =>{
    state.moveshow = value;
},
[types.SETSIGGINGARRLIST]:(state,value) =>{
    state.siggingarrlist=value;
},
[types.DEMOFLAG]:(state,value) =>{
    state.demoFlag=value;
},


}

const actions = {
  setMarkData({ commit }, value) {
      commit(types.SETMARKDATA, value);
  },
  setLocalPage({ commit }, value) {
      commit(types.SETLOCALPAGE, value);
  },
  setOpenTools({ commit }, value) {
      commit(types.OPENTOOLS, value);
  },
  setMarkSelected({ commit }, value) {
      commit(types.MARKSELECTED, value);
  },
  setMarkCreate({ commit }, value) {
      commit(types.MARKCREATE, value);
  },
  setEditNode({ commit }, value) {
      commit(types.EDITNODE, value);
  },
  setCurrentImage({ commit }, value) {
      commit(types.CURRENTIMAGE, value);
  },
  setEditTemplate({ commit }, value) {
      commit(types.EDITTEMPLATE, value);
  },
  setCreateTemplate({ commit }, value) {
      commit(types.CREATETEMPLATE, value);
  },
  setStandardUpdateTotal({ commit }, value) {
      commit(types.STANDARDUPDATETOTAL, value);
  },
  setNavHidden({ commit }, value) {
      commit(types.SETNAVHIDDEN, value);
  },
  setEditType({ commit }, value) {
      commit(types.SETEDITTYPE, value);
  },
  setTestTemplate({ commit }, value) {
      commit(types.SETTESTTEMPLATE, value);
  },
  setCreateTemplateTools({ commit }, value) {
      commit(types.CREATETOOLS, value);
  },
  setCertificateQuery({ commit }, value) {
      commit(types.SETCERTIFICATE, value);
  },
  setImageItem({ commit }, value) {
      commit(types.SETIMAGEITEM, value);
  },
  drawOpen({ commit }, value) {
      commit(types.DRAWOPEN, value);
  },
  setOcrResult({ commit }, value) {
      commit(types.OCRRESULT, value);
  },
  setNeworiginData({ commit }, value) {
      commit(types.NEWORIGIBDATA, value);
  },
  setChangeneworiginData({ commit }, value) {
      commit(types.CHANGENEWORIGIBDATA, value);
  },
  setTabOCR({ commit }, value) {
      commit(types.SETTABOCRNAME, value);
  },
  setEditpageTab({ commit }, value) {
      commit(types.SETEDITPAGETAB, value);
  },
  setGroupList({ commit }, value) {
      commit(types.GROUPLIKST, value);
  },
  setResitem({ commit }, value) {
      commit(types.SETRESITEN, value);
  },
  setItemerror({ commit }, value) {
      commit(types.SETITEMERROR, value);
  },
  setErrornewpage({ commit }, value){
      commit(types.SETERRORNEWPAGE, value)
  },


setSuccessData({ commit }, value) {
    commit(types.SETSUCCESSDATA, value);
},
setFullExpand({ commit }, value) {
    commit(types.SETFULLEXPAND, value);
},

setdocTypeNum({commit},value){
    commit(types.SETDOCTYPENUM,value)
},
setVerifyData({ commit }, value) {
    commit(types.SETVERIFYDATA, value);
},
setOpenToolName({ commit }, value) {
    commit(types.OPENTOOLS, value);
},
setdegrees( { commit }, value){
    commit(types.SETDEGRESS,value);
},

setSwitchAuto({ commit }, value) {
    commit(types.SETSWITVHAUTO, value);
},

setAddRow({ commit }, value) {
    commit(types.SETADDROW, value);
},
setMinusRow({ commit }, value) {
    commit(types.SETMINUSROW, value);
},
setTableInput({ commit }, value) {
    commit(types.SETTABLEINPUT, value);
},
setTableFocus({ commit }, value) {
    commit(types.SETTABLEFOCUS, value);
},
setTableBlur({ commit }, value) {
    commit(types.SETTABLEBLUR, value);
},
setSuccessTotal({ commit }, value) {
    commit(types.SETSUCCESSTOTAL, value);
},
setSuccessAllData({ commit }, value) {
    commit(types.SETSUCCESSALLDATA, value);
},
setTabSwitch({ commit }, value) {
    commit(types.SETTABSWITCH, value);
},

setDocTypeNum({ commit },value) {
    commit(types.SETDOCTYPENUM, value);
},
setmoveshow({ commit },value) {
    commit(types.SETMOVESHOW, value);
},
setSiggingarrlist({commit},value) {
    commit(types.SETSIGGINGARRLIST, value)
},
setDemoFlag({commit},value) {
    commit(types.DEMOFLAG, value)
}
}


export default {
  state,
  getters,
  actions,
  mutations
}